import axios from "axios";

// 🔧 Fonction dédiée à la mise à jour d’un contact enrichi avec des votes par période
export const createProcessRowUpdate = (groupeId, safePeriodes, setContacts) => {
  return async (newRow, oldRow) => {
    const mergedRow = { ...oldRow, ...newRow };

    // 🧩 Construction du payload des périodes
    const periodesPayload = safePeriodes.map((p, i) => ({
      periodeId: p._id,
      valeur: Number(mergedRow[`periode${i + 1}`] || 0)
    }));

    // ✅ Enrichissement de la ligne pour l’API
    const enrichedRow = {
      ...mergedRow,
      groupe: groupeId,
      periodes: periodesPayload,
      combien: periodesPayload.reduce((sum, p) => sum + p.valeur, 0)
    };

  // 🧱 Reconstruction locale avec les valeurs par période
    const finalRow = {
      ...mergedRow,
      ...safePeriodes.reduce((acc, p) => {
      const vote = periodesPayload.find(v => v.periodeId === p._id);
      acc[p._id] = vote?.valeur || 0;
      return acc;
    }, {})
  };

    // 🔹 Mise à jour immédiate du state local
    setContacts(prev => {
      const updated = prev.map(row =>
        row._id === mergedRow._id ? finalRow : row
      );
      return [...updated]; // nouvelle référence
    });

    // 📡 Envoi vers l’API
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API}/contacts/${mergedRow._id}`,
        enrichedRow
      );
      return { ...finalRow, ...res.data };
    } catch (err) {
      console.error("Erreur mise à jour contact :", err);
      return oldRow;
    }
  };
};
